import React from 'react';
import {withRouter, NavLink} from 'react-router-dom'
import {Menu, Icon} from 'antd';

const {SubMenu} = Menu;
import style from './navigationItems.scss';

class navigationItems extends React.Component {
    on_menu_click = ({key}) => {
        this.props.history.replace(key)
    }

    render() {
        return (<div className="header-menu">
            <Menu mode="horizontal"
                  onClick={this.on_menu_click}>
                <SubMenu
                    getPopupContainer={(trigger) => trigger.parentNode}
                    title={
                        <span className="submenu-title-wrapper">
              Account
            </span>
                    }
                >
                    <Menu.Item key={"/admindaccount"}>
                        Account
                    </Menu.Item>
                    <Menu.Item key="/userList">User
                    </Menu.Item>
                </SubMenu>
                <SubMenu
                    getPopupContainer={(trigger) => trigger.parentNode}
                    title={
                        <span className="submenu-title-wrapper">
              Migration
            </span>
                    }
                >
                    <Menu.Item key="/migration">Migration</Menu.Item>
                    <Menu.Item key="/syncReport">Replication Report</Menu.Item>
                    <Menu.Item key="/transferReport">Transfer Report</Menu.Item>
                </SubMenu>
                <SubMenu
                    getPopupContainer={(trigger) => trigger.parentNode}
                    title={
                        <span className="submenu-title-wrapper">
              Product Package
            </span>
                    }
                >
                    <Menu.Item key={'/productPackages'}>
                        Product Packages
                    </Menu.Item>
                    <Menu.Item key={'/productFeatures'}>
                        Product Features
                    </Menu.Item>
                </SubMenu>
                <Menu.Item key="/notifications">
                    Notifications</Menu.Item>
            </Menu>
        </div>);
    }

}

export default withRouter(navigationItems);
